const config = {
  TOKEN_LOCALSTORAGE_KEY: 'deepleid',
  apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  PUBLIC_URL: process.env.PUBLIC_URL,
  SENTRY_ENV: process.env.REACT_APP_SENTRY_ENV || 'development',
  FACEBOOK_APP_ID: process.env.REACT_APP_FACEBOOK_APP_ID,
  FACEBOOK_APP_SECRET: process.env.REACT_APP_FACEBOOK_APP_SECRET,
  FACEBOOK_ENABLE: process.env.REACT_APP_FACEBOOK_ENABLE,
  MESSAGE_USAGE_POLL_INTERVAL: Number(process.env.REACT_APP_MESSAGE_USAGE_POLL_INTERVAL || 30000), // 30 sec
}

module.exports = config



// WEBPACK FOOTER //
// ./src/config.js